import { IExercisePreset } from '#types/exercisePresets';
import { atom, useRecoilState } from 'recoil';

const ATOM_KEY = 'exercise-preset';

export const defaultSetType = 'REPWEIGHT';

export const $exercisePreset = atom<Omit<IExercisePreset, 'id'>>({
  key: ATOM_KEY,

  default: {
    name: '',
    // 운동 내역
    exercisePresetWorkout: [
      {
        exerciseTypeId: '',
        sets: [
          {
            setType: defaultSetType,
            round: 1
          }
        ]
      }
    ]
  }
});

// api에 추가할 프리셋 관리
export const useExercisePresetRecoil = () => {
  const [exercisePresets, setExercisePresets] = useRecoilState($exercisePreset);

  return { exercisePresets, setExercisePresets };
};

// 운동차트 작성에 들어갈 프리셋 관리
export const $exercisePresetChart = atom<IExercisePreset[]>({
  key: 'exercise-preset-chart',
  default: []
});

export const useExercisePresetChartRecoil = () => {
  const [exercisePresetChart, setExercisePresetChart] =
    useRecoilState($exercisePresetChart);

  return { exercisePresetChart, setExercisePresetChart };
};
